import { Location } from '@angular/common';
import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { filter, firstValueFrom, Subscription } from 'rxjs';
import { AuthenticationContants } from 'src/app/constants/authentication-constants';
import { ProjectName } from 'src/app/constants/project-name-constants';
import { AccountingSystemEnums } from 'src/app/enum/accouting-system-enums';
import { BussinessDocumentsClassEnums } from 'src/app/enum/bussiness-documets-class-enums';
import { FormatsEnums } from 'src/app/enum/formats-enums';
import { GeneralParameterEnums } from 'src/app/enum/general-parameter-enums';
import { InternalOrderEnums } from 'src/app/enum/internal-order-enums';
import { InventoryOutputStateEnums } from 'src/app/enum/inventory-output-state-enums';
import { InventoryOutputTypeEnums } from 'src/app/enum/inventory-output-type-enums';
import { FormatModel } from 'src/app/models/formats/format.model';
import { InventoryOutputModel } from 'src/app/models/inventory/inventory-output.model';
import { BranchModel } from 'src/app/models/management/branch.model';
import { InventoryOutputPrintModel } from 'src/app/models/print/inventory/inventory-output-print.model';
import { InternalOrderModel } from 'src/app/models/shopping/internal-order.model';
import { ArticleService } from 'src/app/services/archive/article.service';
import { UserService } from 'src/app/services/authentication/user.service';
import { WindowService } from 'src/app/services/authentication/window.service';
import { ConfirmDialogService } from 'src/app/services/confirm-dialog/confirm-dialog.service';
import { FormatService } from 'src/app/services/formats/format.service';
import { DateConverterService } from 'src/app/services/global-services/date-converter.service';
import { FormControlStateService } from 'src/app/services/global-services/form-control-state.service';
import { UserAuthenticatedService } from 'src/app/services/global-services/user-authenticated.service';
import { HeaderService } from 'src/app/services/header/header.service';
import { InventoryOutputService } from 'src/app/services/inventory/inventory-output.service';
import { InventoryService } from 'src/app/services/inventory/inventory.service';
import { MaintenanceOrderService } from 'src/app/services/maintenance/maintenance-order.service';
import { BranchService } from 'src/app/services/management/branch.service';
import { InternalOrderService } from 'src/app/services/shopping/internal-order.service';
import { ToastHandlerService } from 'src/app/services/toast/toast-handler.service';

@Component({
  selector: 'app-register-inventory-output',
  templateUrl: './register-inventory-output.component.html',
  styleUrls: ['./register-inventory-output.component.scss'],
  standalone: false
})
export class RegisterInventoryOutputComponent implements OnInit, OnDestroy {
  branchId: number = 0;
  companyId: number = 0;
  devolutionNumber: number | null = 0;
  disabledDetail: boolean = true;
  disabledForm: boolean = false;
  formatModel: FormatModel = new FormatModel();
  formInventoryOutput: FormGroup = new FormGroup({});
  hasQuantityInZero: boolean = false;
  iconState: string = '';
  inventoryId: number = 0;
  inventoryOutputTypeId: number = InventoryOutputTypeEnums.output;
  inventoryOutputContract: InventoryOutputModel = new InventoryOutputModel();
  inventoryOutputId: number = 0;
  inventoryOutputPrintModel: InventoryOutputPrintModel = new InventoryOutputPrintModel();
  invoiceNumber: number | null = 0;
  isASADMIN: boolean = false;
  isOpened: string | undefined = undefined;
  labelInvoice: boolean = true;
  listBranch: any[] = [];
  listClient: any[] = [];
  listConcept: any[] = [];
  listInventory: any[] = [];
  listInventoryOutputType: any[] = [];
  listObservers: Subscription[] = [];
  mainBranchByUser: BranchModel = new BranchModel();
  maintenanceOrderClassText: string = '';
  maintenanceOrderConsecutiveText: string = '';
  maintenanceOrderEquipmentText: string = '';
  nameWindow: string = 'Captura Salidas de Inventario';
  permissionPrint: boolean = false;
  permissionUpdatable: boolean = false;
  projectName = ProjectName.projectName;
  quantityDetails: number = 0;
  reloadPrint: boolean = false;
  responsible: string = '';
   siesaSynchronization: boolean = false;
  showRequieredOrder: boolean = false;
  stateOpen: number = InventoryOutputStateEnums.open;
  stateText: string = '';
  swAllowsNegativeShopBalances: boolean = false;
  titleState: string = '';
  url: string = 'inventory-output';
  visibleDevolution: boolean = false;
  visibleInvoice: boolean = false;

  constructor(private activatedRoute: ActivatedRoute,
    private articleService: ArticleService,
    private branchService: BranchService,
    private confirmDialogService: ConfirmDialogService,
    private dateConverterService: DateConverterService,
    private formBuilder: FormBuilder,
    private formControlStateService: FormControlStateService,
    private formatService: FormatService,
    private headerService: HeaderService,
    private internalOrderService: InternalOrderService,
    private inventoryService: InventoryService,
    private inventoryOutputService: InventoryOutputService,
    private maintenanceOrderService: MaintenanceOrderService,
    private location: Location,
    private router: Router,
    private title: Title,
    private toastHandlerService: ToastHandlerService,
    private userAuthenticatedService: UserAuthenticatedService,
    private userService: UserService,
    private windowService: WindowService) {
    this.validateForm(this.inventoryOutputContract);
  }

  async ngOnInit() {
    this.title.setTitle(`${this.nameWindow} - ${this.projectName}`);
    this.headerService.setTitle(this.nameWindow);
    await this.getPermission();
    this.activatedRoute.params.subscribe(params => {
      this.inventoryOutputId = Object.keys(params).length > 0 ? params?.id : null;
    });
    this.handleInitialState();
  }

  @HostListener('window:beforeunload')
  beforeUnloadHandler() {
    this.ngOnDestroy();
  }

  ngOnDestroy() {
    this.listObservers.forEach(x => x.unsubscribe());
    const windowsOpenedJson = localStorage.getItem(AuthenticationContants.keyWindowsOpenedLocalStorage);
    if (windowsOpenedJson) {
      const windowsOpened: Array<string> = JSON.parse(windowsOpenedJson);
      const window = windowsOpened.findIndex(x => x === this.url);
      if (window != -1) {
        windowsOpened.splice(window, 1);
        localStorage.setItem(AuthenticationContants.keyWindowsOpenedLocalStorage, JSON.stringify(windowsOpened));
      }
    }
  }

  async changeBranch(branchId: number | null, reload: boolean) {
    this.branchId = branchId ?? 0;
    this.formInventoryOutput.controls["branchId"].patchValue(this.branchId);
    if (reload) {
      this.changeSelection();
    }
  }


  async changeConsecutive() {
    const inventoryId = this.formInventoryOutput.get("inventoryId")?.value;
    const branchId = this.formInventoryOutput.get("branchId")?.value;
    const inventoryOutputTypeId = this.formInventoryOutput.get("inventoryOutputTypeId")?.value;
    let consecutive = this.formInventoryOutput.get("consecutive")?.value;

    if (inventoryId === null || inventoryId === 0) {
      this.toastHandlerService.showToast(
        'warning',
        'Seleccione un inventario.'
      );
      return;
    } else if (branchId === null || branchId === 0) {
      this.toastHandlerService.showToast(
        'warning',
        'Seleccione una sucursal.'
      );
      return;
    } else if (inventoryOutputTypeId === null || inventoryOutputTypeId === 0) {
      this.toastHandlerService.showToast(
        'warning',
        'Seleccione un tipo de salida.'
      );
      return;
    } else if (consecutive <= 0) {
      consecutive = 0;
    }

    if (consecutive === 0) {
      const modelInventoryOutput = new InventoryOutputModel();
      this.inventoryOutputId = modelInventoryOutput.inventoryOutputId;
      modelInventoryOutput.branchId = branchId;
      modelInventoryOutput.inventoryId = inventoryId;
      this.inventoryOutputContract = modelInventoryOutput;
      this.validateForm(this.inventoryOutputContract);
      this.location.replaceState(`/inventory-output/register`);
    } else {
      try {
        this.inventoryOutputContract = await firstValueFrom(
          this.inventoryOutputService.getInventoryOutputByKeysAsync(inventoryId, branchId, inventoryOutputTypeId, consecutive)
        );
        this.inventoryOutputId = this.inventoryOutputContract.inventoryOutputId;
        this.validateForm(this.inventoryOutputContract);
        this.location.replaceState(`/inventory-output/register/${this.inventoryOutputId}`);
      } catch (error) {
        this.createNewInventoryOutput();
        console.error('Error al obtener la salida de inventario por claves:', error);
      }
    }
  }

  async changeConsecutiveInternalOrder() {
    const branchId = this.formInventoryOutput.get("branchId")?.value;
    const internalOrderConsecutive = this.formInventoryOutput.get("internalOrderConsecutive")?.value;
    try {
      const internalOrder = await firstValueFrom(this.internalOrderService.getInternalOrderByKeysAsync(branchId, internalOrderConsecutive));
      if (internalOrder) {
        if (internalOrder.internalOrderState !== InternalOrderEnums.close) {
          this.responsible = '';
          this.formInventoryOutput.controls['internalOrderConsecutive'].patchValue(0);
          this.formInventoryOutput.controls['internalOrderId'].patchValue(0);
          this.resetMaintenanceOrderDisplay();
          this.toastHandlerService.showToast('warning', 'El pedido interno debe estar en estado cerrado para ser asociado a la salida de inventario.');
          return;
        }
        this.responsible = internalOrder.responsible;
        this.formInventoryOutput.controls['internalOrderId'].patchValue(internalOrder.internalOrderId);
        await this.setMaintenanceOrderDisplay(internalOrder);
      }
    } catch (error) {
      this.responsible = '';
      this.formInventoryOutput.controls['internalOrderConsecutive'].patchValue(0);
      this.formInventoryOutput.controls['internalOrderId'].patchValue(0);
      this.resetMaintenanceOrderDisplay();
      console.error('Error al obtener el pedido interno por claves:', error);
    }
  }

  async changeInventory(inventoryId: number | null, reload: boolean) {
    let validInventory = null;

    if (inventoryId != null) {
      const inventory = await firstValueFrom(this.inventoryService.getInventoryById(inventoryId));
      if (inventory) {
        validInventory = inventoryId;
        this.showRequieredOrder = inventory.swInternalOrder;
      }
    }

    this.inventoryId = validInventory ?? 0;
    this.formInventoryOutput.controls["inventoryId"].patchValue(validInventory);

    if (reload) {
      this.changeSelection();
    }
  }


  changeInventoryOutputType(inventoryOutputTypeId: number) {
    this.inventoryOutputTypeId = inventoryOutputTypeId;
    this.changeSelection();
  }

  changeSelection() {
    this.inventoryOutputId = 0;
    const modelInventoryOutput = new InventoryOutputModel();
    modelInventoryOutput.inventoryId = this.inventoryId;
    modelInventoryOutput.branchId = this.branchId;
    modelInventoryOutput.inventoryOutputTypeId = this.inventoryOutputTypeId;
    modelInventoryOutput.swInternalOrder = this.showRequieredOrder;

    this.inventoryOutputContract = modelInventoryOutput;
    this.validateForm(this.inventoryOutputContract);
    this.location.replaceState(`/inventory-output/register`);
  }

  changeQuantityDetails(quantity: number) {
    this.quantityDetails = quantity;
    this.updateFormState();
  }

  changeRequieredInternalOrder() {
    const requieredInternalOrder = this.formInventoryOutput.get("swInternalOrder")?.value;
    if (requieredInternalOrder) {
      this.formControlStateService.setControlState(this.formInventoryOutput, 'internalOrderConsecutive', true);
    } else {
      this.formInventoryOutput.controls['internalOrderConsecutive'].patchValue(0);
      this.formInventoryOutput.controls['internalOrderId'].patchValue(null);
      setTimeout(() => { this.formControlStateService.setControlState(this.formInventoryOutput, 'internalOrderConsecutive', false) }, 100);
      this.responsible = '';
      this.resetMaintenanceOrderDisplay();
    }
  }

  async changeState() {
    if (this.inventoryOutputContract.inventoryOutputId !== 0 || this.inventoryOutputContract.inventoryOutputId !== null) {
      if (this.permissionUpdatable) {
        if (this.hasQuantityInZero) {
          this.toastHandlerService.showToast('warning', 'No puede cambiar el estado de la salida de inventario si tiene detalles con cantidades en cero.');
          return;
        }

        if (!this.validateTypeInventoryOutput(this.inventoryOutputContract.inventoryOutputTypeId, 'abrir')) return;

        try {
          this.inventoryOutputContract = await firstValueFrom(
            this.inventoryOutputService.setInventoryOutputState(this.inventoryOutputContract.inventoryOutputId)
          );
          this.validateForm(this.inventoryOutputContract);
          this.toastHandlerService.showToast('success', 'El estado de la salida de inventario se modificó exitosamente.');
        } catch (error) {
          console.error('Error al cambiar el estado de la salida de inventario.', error);
        }
      } else {
        this.toastHandlerService.showToast(
          'warning',
          'El usuario no tiene permisos para modificar salidas de inventario. Comuníquese con el administrador del sistema.'
        );
        return;
      }
    } else {
      this.toastHandlerService.showToast(
        'warning',
        'Debe crear una Salida de Inventario.'
      );
      return;
    }
  }

  createNewInventoryOutput() {
    if (!this.permissionUpdatable) {
      this.toastHandlerService.showToast('warning', 'El usuario no tiene permisos para crear salidas de inventario. Comuníquese con el administrador del sistema');
      return;
    }
    if (this.inventoryOutputTypeId !== InventoryOutputTypeEnums.output) {
      this.toastHandlerService.showToast('warning', 'Solo está permitido crear una salidas de inventario del tipo Salida');
    }

    this.inventoryOutputContract = new InventoryOutputModel();
    this.inventoryOutputId = 0;
    this.inventoryOutputContract.inventoryId = this.inventoryId;
    this.inventoryOutputContract.branchId = this.branchId;
    this.inventoryOutputContract.inventoryOutputTypeId = InventoryOutputTypeEnums.output;
    this.inventoryOutputContract.swInternalOrder = this.showRequieredOrder;
    this.inventoryOutputTypeId = InventoryOutputTypeEnums.output;
    this.inventoryOutputContract.consecutive = 0;
    this.disabledForm = false;
    this.validateForm(this.inventoryOutputContract);
    this.visibleDevolution = false;
    this.devolutionNumber = 0;
    this.invoiceNumber = 0;
    this.resetMaintenanceOrderDisplay();
    this.disabledDetail = true;
    this.quantityDetails = 0;
    this.location.replaceState(`/inventory-output/register`);
  }

  async deleteAllBalances() {
    if (await this.confirmDialogService.confirm(`¿Realmente desea eliminar todas las existencias del almacén de este inventario?`)) {
      try {
        this.inventoryOutputContract = await firstValueFrom(this.inventoryOutputService.deleteAllBalances(this.inventoryOutputId));
      } catch (error) {
        console.error('Error al buscar los master filters de consulta detalle de la salidas de inventario.', error);
      }
    }
  }

  async deleteInventoryOutput() {
    if (this.inventoryOutputContract.inventoryOutputId != 0 && this.inventoryOutputContract.inventoryOutputId != null) {
      if (this.permissionUpdatable) {
        if (!this.validateTypeInventoryOutput(this.inventoryOutputContract.inventoryOutputTypeId, 'eliminar')) return;

        if (this.inventoryOutputContract.inventoryOutputStateId === InventoryOutputStateEnums.open) {
          if (await this.confirmDialogService.confirm(`¿Realmente desea eliminar la salida de inventario actual?`)) {
            try {
              await firstValueFrom(this.inventoryOutputService.deleteInventoryOutput(this.inventoryOutputId));
              this.createNewInventoryOutput();
              this.toastHandlerService.showToast(
                'success',
                'La salida de inventario fue eliminada exitosamente.'
              );
            } catch (error) {
              console.error("Error al eliminar la salida de inventario: ", error);
            }
          }
        } else {
          this.toastHandlerService.showToast(
            'warning',
            'Para eliminar la salida de inventario debe estar en estado Abierta.'
          );
        }
      } else {
        this.toastHandlerService.showToast(
          'warning',
          'El usuario no tiene permisos para eliminar salidas de inventario. Comuníquese con el administrador del sistema.'
        );
        return;
      }
    } else {
      this.toastHandlerService.showToast(
        'warning',
        'Debe crear una Salida de Inventario.'
      );
      return;
    }
  }

  async editInventoryOutput() {
    await this.getInventoryOutputById();
  }

  finishLoading(finishPrint: boolean) {
    if (finishPrint) {
      window.print();
    }
  }

  async getAllLists() {
    try {
      const [inventories, branches, inventoryOutputTypes, concepts, clients] = await Promise.all([
        firstValueFrom(this.inventoryOutputService.getAllInventoriesForSelectAsync()),
        firstValueFrom(this.branchService.getAllBranchesForSelectAsync()),
        firstValueFrom(this.inventoryOutputService.getAllInventoryOutputTypesForSelectAsync()),
        firstValueFrom(this.inventoryOutputService.getAllConceptsForSelectAsync()),
        firstValueFrom(this.inventoryOutputService.getAllClientsForSelectAsync()),
      ]);

      this.listInventory = inventories;
      this.listBranch = branches;
      this.listInventoryOutputType = inventoryOutputTypes;
      this.listConcept = concepts;
      this.listClient = clients;

      return true;
    } catch (error) {
      console.error('Error al obtener las listas.', error);
      return false;
    }
  }

  async getButtonClick(buttonClick: any) {
    const inventoryId = this.formInventoryOutput.get("inventoryId")?.value;
    const branchId = this.formInventoryOutput.get("branchId")?.value;
    const inventoryOutputTypeId = this.formInventoryOutput.get("inventoryOutputTypeId")?.value;
    let consecutive = this.formInventoryOutput.get("consecutive")?.value;

    if (inventoryId === null || inventoryId === 0) {
      this.toastHandlerService.showToast(
        'warning',
        'Seleccione un inventario.'
      );
      return;
    } else if (branchId === null || branchId === 0) {
      this.toastHandlerService.showToast(
        'warning',
        'Seleccione una sucursal.'
      );
      return;
    } else if (inventoryOutputTypeId === null || inventoryOutputTypeId === 0) {
      this.toastHandlerService.showToast(
        'warning',
        'Seleccione un tipo de salida.'
      );
      return;
    } else if (consecutive === null || consecutive === undefined) {
      consecutive = 0;
    }

    switch (buttonClick.target.id) {
      case 'first': {
        try {
          this.inventoryOutputContract = await firstValueFrom(
            this.inventoryOutputService.getFirstInventoryOutputByKeysAsync(inventoryId, branchId, inventoryOutputTypeId)
          );
          this.inventoryOutputId = this.inventoryOutputContract.inventoryOutputId;
          this.validateForm(this.inventoryOutputContract);
          this.location.replaceState(`/inventory-output/register/${this.inventoryOutputId}`);
        } catch (error) {
          console.error('Error al obtener la primera salida de inventario por claves:', error);
        }
        break;
      }
      case 'previus': {
        try {
          this.inventoryOutputContract = await firstValueFrom(
            this.inventoryOutputService.getPreviusInventoryOutputByKeysAsync(inventoryId, branchId, inventoryOutputTypeId, consecutive)
          );
          this.inventoryOutputId = this.inventoryOutputContract.inventoryOutputId;
          this.validateForm(this.inventoryOutputContract);
          this.location.replaceState(`/inventory-output/register/${this.inventoryOutputId}`);
        } catch (error) {
          console.error('Error al obtener la anterior salida de inventario por claves:', error);
        }
        break;
      }
      case 'next': {
        try {
          this.inventoryOutputContract = await firstValueFrom(
            this.inventoryOutputService.getNextInventoryOutputByKeysAsync(inventoryId, branchId, inventoryOutputTypeId, consecutive)
          );
          this.inventoryOutputId = this.inventoryOutputContract.inventoryOutputId;
          this.validateForm(this.inventoryOutputContract);
          this.location.replaceState(`/inventory-output/register/${this.inventoryOutputId}`);
        } catch (error) {
          console.error('Error al obtener la siguiente salida de inventario por claves:', error);
        }
        break;
      }
      case 'last': {
        try {
          this.inventoryOutputContract = await firstValueFrom(
            this.inventoryOutputService.getLastInventoryOutputByKeysAsync(inventoryId, branchId, inventoryOutputTypeId)
          );
          this.inventoryOutputId = this.inventoryOutputContract.inventoryOutputId;
          this.validateForm(this.inventoryOutputContract);
          this.location.replaceState(`/inventory-output/register/${this.inventoryOutputId}`);
        } catch (error) {
          console.error('Error al obtener la última salida de inventario por claves:', error);
        }
        break;
      }
    }
  }

  async getClient(clientId: number | null) {
    const clientOld = this.inventoryOutputContract.clientId;
    if (clientId != null) {
      const client = this.listClient.find(x => x.value == clientId);
      if (client) {
        if (clientOld != clientId) {
          if (this.quantityDetails != 0) {
            if (await this.confirmDialogService.confirm(`La salida tiene artículos asociados. ¿Realmente desea modificar el cliente?`)) {
              this.formInventoryOutput.controls["clientId"].patchValue(clientId);
              this.disabledDetail = true;
            } else {
              this.formInventoryOutput.controls["clientId"].patchValue(clientOld);
            }
          } else {
            this.formInventoryOutput.controls["clientId"].patchValue(clientId);
            this.disabledDetail = true;
          }
        }
      } else {
        if (this.quantityDetails != 0) {
          this.formInventoryOutput.controls["clientId"].patchValue(clientOld);
          this.toastHandlerService.showToast(
            'warning',
            'Error al buscar el elemento. Por favor refresque la página.'
          );
        } else {
          this.formInventoryOutput.controls["clientId"].patchValue(0);
          this.disabledDetail = true;
        }
      }
    } else {
      if (this.quantityDetails != 0) {
        this.formInventoryOutput.controls["clientId"].patchValue(clientOld);
        this.toastHandlerService.showToast(
          'warning',
          'No puede limpiar el cliente si la salida tiene detalle.'
        );
      } else {
        this.formInventoryOutput.controls["clientId"].patchValue(0);
        this.disabledDetail = true;
      }
    }
  }

  async getConcept(conceptId: number | null) {
    const conceptOld = this.inventoryOutputContract.conceptId;
    if (conceptId != null && conceptId != 0) {
      const concept = this.listConcept.find(x => x.value === conceptId);
      if (concept) {
        if (conceptOld != conceptId) {
          if (this.quantityDetails != 0) {
            if (await this.confirmDialogService.confirm(`La salida tiene artículos asociados. ¿Realmente desea modificar el concepto?`)) {
              this.formInventoryOutput.controls["conceptId"].patchValue(conceptId);
              this.disabledDetail = true;
            } else {
              this.formInventoryOutput.controls["conceptId"].patchValue(conceptOld);
            }
          } else {
            this.disabledDetail = true;
          }
        }
      } else {
        if (this.quantityDetails != 0) {
          this.formInventoryOutput.controls["conceptId"].patchValue(conceptOld);
          this.toastHandlerService.showToast(
            'warning',
            'No puede limpiar el concepto si la salida tiene detalle.'
          );
        } else {
          this.formInventoryOutput.controls["conceptId"].patchValue(0);
          this.disabledDetail = true;
        }
      }
    } else {
      if (this.quantityDetails != 0) {
        this.formInventoryOutput.controls["conceptId"].patchValue(conceptOld);
        this.toastHandlerService.showToast(
          'warning',
          'No puede limpiar el concepto si la salida tiene detalle.'
        );
      } else {
        this.formInventoryOutput.controls["conceptId"].patchValue(0);
        this.disabledDetail = true;
      }
    }
  }

  async getFirstBranchByUserAuthenticatedAsync() {
    try {
      this.mainBranchByUser = await firstValueFrom(this.userAuthenticatedService.branchObservable.pipe(filter(branch => branch && branch.branchId !== 0)));
      this.companyId = this.mainBranchByUser.companyId;
      this.branchId = this.mainBranchByUser.branchId;
      this.changeBranch(this.branchId, false);
    } catch (error) {
      console.error('Error al obtener la primera sucursal por usuario autenticado:', error);
    }
  }

  async getFirstInventoryByCompanyAuthenticatedAsync() {
    try {
      const response = await firstValueFrom(this.inventoryService.getFirstInventoryByCompanyAuthenticatedAsync());
      this.inventoryId = response.inventoryId;
      await this.changeInventory(response.inventoryId, false);
      this.getFirstBranchByUserAuthenticatedAsync();
    } catch (error) {
      console.error('Error al obtener el primer inventario por empresa autenticada:', error);
    }
  }

  async getFormatByCompanyAndCode() {
    if (this.formatModel.formatId == 0) {
      this.formatModel = await firstValueFrom(this.formatService.getFormatByCompanyAndCode(this.companyId!, FormatsEnums.inventoryOutput));
    }
  }

  getGeneralParametersByCompany() {
    const load = this.userAuthenticatedService.generalParameterObservable.subscribe(response => {
      this.swAllowsNegativeShopBalances = response.some(x => x.generalParameterId === GeneralParameterEnums.permitirNegativosAlmacen);
    });
    this.listObservers.push(load);
  }

  async getInventoryOutputById() {
    try {
      this.inventoryOutputContract = await firstValueFrom(this.inventoryOutputService.getInventoryOutputById(this.inventoryOutputId));
      this.inventoryOutputId = this.inventoryOutputContract.inventoryOutputId;
      this.branchId = this.inventoryOutputContract.branchId;
      this.inventoryId = this.inventoryOutputContract.inventoryId;
      this.inventoryOutputTypeId = this.inventoryOutputContract.inventoryOutputTypeId;
      this.showRequieredOrder = this.inventoryOutputContract.inventory?.swInternalOrder || false;
      this.formInventoryOutput.controls['swInternalOrder'].patchValue(this.showRequieredOrder);
      this.validateForm(this.inventoryOutputContract);
      this.location.replaceState(`/inventory-output/register/${this.inventoryOutputId}`);
    } catch (error) {
      console.error('Error al obtener la salida de inventario por ID.', error);
    }
  }

  async getInventoryOutputByKeysForPrint() {
    try {
      this.inventoryOutputPrintModel = await firstValueFrom(
        this.inventoryOutputService.getInventoryOutputByKeysForPrintAsync(
          this.inventoryOutputContract.inventoryOutputId, this.inventoryOutputContract.inventoryId, this.inventoryOutputContract.branchId,
          this.inventoryOutputContract.inventoryOutputTypeId, 0
        )
      );
    } catch (error) {
      console.error('Error al obtener la salida de inventario por claves.', error);
    }
  }

  private getMaintenanceOrderClassText(maintenanceOrderClassId: number | null | undefined): string {
    if (!maintenanceOrderClassId) {
      return '';
    }

    const classMap: Record<number, string> = {
      1: 'En Taller',
      2: 'En Sitio'
    };

    return classMap[maintenanceOrderClassId] || '';
  }

  private resetMaintenanceOrderDisplay(): void {
    this.maintenanceOrderClassText = '';
    this.maintenanceOrderConsecutiveText = '';
    this.maintenanceOrderEquipmentText = '';
  }

  private async setMaintenanceOrderDisplay(internalOrder: InternalOrderModel | null): Promise<void> {
    if (!internalOrder) {
      this.resetMaintenanceOrderDisplay();
      return;
    }

    let maintenanceOrder = internalOrder.maintenanceOrder;
    if (!maintenanceOrder && internalOrder.maintenanceOrderId) {
      try {
        maintenanceOrder = await firstValueFrom(this.maintenanceOrderService.getMaintenanceOrderById(internalOrder.maintenanceOrderId));
      } catch (error) {
        this.resetMaintenanceOrderDisplay();
        console.error('Error al obtener la OM asociada al pedido interno.', error);
        return;
      }
    }

    if (!maintenanceOrder) {
      this.resetMaintenanceOrderDisplay();
      return;
    }

    this.maintenanceOrderClassText = this.getMaintenanceOrderClassText(maintenanceOrder.maintenanceOrderClassId);
    this.maintenanceOrderConsecutiveText = maintenanceOrder.consecutive ? maintenanceOrder.consecutive.toString() : '';
    this.maintenanceOrderEquipmentText = '';

    if (maintenanceOrder.articleId) {
      try {
        const article = await firstValueFrom(this.articleService.getArticleById(maintenanceOrder.articleId));
        this.maintenanceOrderEquipmentText = article ? `${article.code} - ${article.name}` : '';
      } catch (error) {
        this.maintenanceOrderEquipmentText = '';
        console.error('Error al obtener el equipo de la OM asociada.', error);
      }
    }
  }

  private async setMaintenanceOrderDisplayFromInventoryOutput(inventoryOutput: InventoryOutputModel): Promise<void> {
    const hasInternalOrder = inventoryOutput.internalOrderId !== null;
    const maintenanceOrderId = inventoryOutput.internalOrder?.maintenanceOrderId;

    if (hasInternalOrder && maintenanceOrderId !== null && maintenanceOrderId !== undefined) {
      await this.setMaintenanceOrderDisplay(inventoryOutput.internalOrder);
      return;
    }

    this.resetMaintenanceOrderDisplay();
  }

   async getCompanyById() {
    const company = await firstValueFrom(
      this.userAuthenticatedService.companyObservable.pipe(filter((company) => company && company.companyId !== 0)));
      this.siesaSynchronization = company.accountingSystemId === AccountingSystemEnums.siesaCloud;
  }

  async getPermission() {
    const windowsOpenedJson = localStorage.getItem(AuthenticationContants.keyWindowsOpenedLocalStorage);
    if (windowsOpenedJson) {
      const windowsOpened: Array<string> = JSON.parse(windowsOpenedJson);
      this.isOpened = windowsOpened.find(x => x === this.url);
      windowsOpened.push(this.url);
      localStorage.setItem(AuthenticationContants.keyWindowsOpenedLocalStorage, JSON.stringify(windowsOpened));
      if (this.isOpened) {
        this.toastHandlerService.showToast(
          'warning',
          `No se permite tener dos ventanas/pestañas de ${this.nameWindow} abiertas.`
        );
      }
    } else {
      localStorage.clear();
    }
    try {
      this.permissionUpdatable = await firstValueFrom(this.windowService.getPermissionProfileByUrl(this.url));
      await this.getCompanyById();
      await this.getAllLists();
      this.userAuthenticatedIsASADMIN();
      await this.getFirstInventoryByCompanyAuthenticatedAsync();
      await this.getFormatByCompanyAndCode();
      this.getPermissionPrint();
      this.getGeneralParametersByCompany();
    } catch (error) {
      console.error('Error al obtener permisos de perfil.', error);
    }
  }

  async getPermissionPrint() {
    try {
      this.permissionPrint = await firstValueFrom(this.inventoryOutputService.getPermissionPrint());
    } catch (error) {
      console.error('Error al obtener permisos de impresión.', error);
    }
  }

  goToBack(event: Event) {
    event.preventDefault();
    this.router.navigate(['/inventory-output']);
  }

  async handleInitialState() {
    if (this.inventoryOutputId !== null && this.inventoryOutputId !== 0) {
      this.editInventoryOutput();
    } else {
      this.createNewInventoryOutput();
    }
  }

  async printPage() {
    if (this.inventoryOutputContract.inventoryOutputId == 0 || this.inventoryOutputContract.inventoryOutputId == null) {
      this.toastHandlerService.showToast(
        'warning',
        'Debe crear una salida de inventario.'
      );
      return;
    }

    if (this.hasQuantityInZero) {
      this.toastHandlerService.showToast(
        'warning',
        'No puede imprimir la salida de inventario si tiene detalles con cantidades en cero.'
      );
      return;
    }

    if (!this.permissionPrint) {
      this.toastHandlerService.showToast(
        'error',
        'El usuario no tiene permisos para imprimir salidas de inventario. Comuníquese con el administrador del sistema.'
      );
      return;
    }

    this.toastHandlerService.clearAllToasts();
    await this.getFormatByCompanyAndCode();
    await this.getInventoryOutputByKeysForPrint();
  }

  async send() {
    Object.keys(this.formInventoryOutput.controls).forEach(key => {
      const control = this.formInventoryOutput.get(key);
      if (control && control.invalid) {
        console.warn(`${key} es inválido`, control.errors, 'value:', control.value);
      }
    });
    if (this.formInventoryOutput.valid) {
      const modelInventoryOutput = this.formInventoryOutput.getRawValue() as InventoryOutputModel;
      if (modelInventoryOutput.swInternalOrder) {
        if (!modelInventoryOutput.internalOrderId || modelInventoryOutput.internalOrderId === 0) {
          this.formInventoryOutput.controls['swInternalOrder'].patchValue(false);
          this.changeRequieredInternalOrder();
          this.toastHandlerService.showToast(
            'warning',
            'El campo Nro. Pedido Interno es obligatorio.'
          );
          return;
        }
      }
      //Hago null, los campos que permiten ser nulos:
      if (modelInventoryOutput.observation?.trim() === "") modelInventoryOutput.observation = null;

      if (this.inventoryOutputId == 0) {
        try {
          this.inventoryOutputContract = await firstValueFrom(this.inventoryOutputService.createInventoryOutput(modelInventoryOutput));
          this.inventoryOutputId = this.inventoryOutputContract.inventoryOutputId;
          await this.getInventoryOutputById();
          this.toastHandlerService.showToast(
            'success',
            'La salida fue creada exitosamente.'
          );
          this.location.replaceState(`/inventory-output/register/${this.inventoryOutputId}`);
        } catch (error) {
          console.error('Error al crear la salida de inventario:', error);
        }
      } else {
        this.inventoryOutputContract.conceptId = modelInventoryOutput.conceptId;
        this.inventoryOutputContract.dateOutput = modelInventoryOutput.dateOutput;
        this.inventoryOutputContract.observation = modelInventoryOutput.observation;
        this.inventoryOutputContract.clientId = modelInventoryOutput.clientId;
        this.inventoryOutputContract.swInternalOrder = modelInventoryOutput.swInternalOrder;
        this.inventoryOutputContract.internalOrderId = modelInventoryOutput.internalOrderId;

        try {
          await firstValueFrom(this.inventoryOutputService.updateInventoryOutput(this.inventoryOutputContract));
          await this.getInventoryOutputById();
          this.toastHandlerService.showToast(
            'success',
            'La salida fue modificada exitosamente.'
          );
        } catch (error) {
          console.error('Error al actualizar la salida de inventario:', error);
        }
      }
    } else {
      this.showValidationMessages();
    }
  }

  showValidationMessages() {
    const controlMessages: Record<string, Record<string, string>> = {
      inventoryId: {
        required: 'El campo Inventario es obligatorio.',
        min: 'Debes seleccionar un Inventario válido.'
      },
      branchId: {
        required: 'El campo Sucursal es obligatorio.',
        min: 'Debes seleccionar una Sucursal válida.'
      },
      inventoryOutputTypeId: {
        required: 'El campo Tipo es obligatorio.',
        min: 'Debes seleccionar un Tipo válido.'
      },
      conceptId: {
        required: 'El campo Concepto es obligatorio.',
        min: 'Debes seleccionar un Concepto válido.'
      },
      clientId: {
        required: 'El campo Cliente es obligatorio.',
        min: 'Debes seleccionar un Cliente válido.'
      },
      dateOutput: {
        required: 'La Fecha de la Salida es obligatoria.'
      },
      observation: {
        maxlength: 'La Observación no puede tener más de 250 caracteres.'
      }
    };

    Object.keys(controlMessages).forEach((control) => {
      const formControl = this.formInventoryOutput.get(control);
      if (formControl && formControl.invalid && formControl.errors) {
        const messages = controlMessages[control];
        Object.keys(formControl.errors).forEach((errorKey) => {
          const message = messages[errorKey];
          if (message) {
            this.toastHandlerService.showToast('warning', message);
          }
        });
      }
    });
  }

  async updateFormState() {
    if (this.inventoryOutputContract.inventoryOutputStateId == InventoryOutputStateEnums.open) {
      this.stateText = 'Abierto';
      this.titleState = 'Cerrar';
      this.iconState = 'pi pi-lock-open';
      this.disabledForm = false;
      this.disabledDetail = false;
      setTimeout(() => this.formInventoryOutput.enable(), 100);
      if (this.inventoryOutputId !== 0) {
        setTimeout(() => this.formInventoryOutput.controls["consecutive"].enable(), 100);
      } else {
        setTimeout(() => this.formInventoryOutput.controls["consecutive"].disable(), 100);
      }
    } else {
      this.stateText = 'Cerrado';
      this.titleState = 'Abrir';
      this.iconState = 'pi pi-lock';
      this.disabledForm = true;
      this.disabledDetail = true;
      setTimeout(() => this.formInventoryOutput.disable(), 100);
    }
    if (!this.permissionUpdatable) {
      this.disabledForm = true;
      this.disabledDetail = true;
      setTimeout(() => this.formInventoryOutput.disable(), 100);
    }
    setTimeout(() => this.formControlStateService.setControlState(
      this.formInventoryOutput, ['inventoryId', 'branchId', 'inventoryOutputTypeId', 'consecutive'], true
    ), 100);
    //Reposicion
    if (this.inventoryOutputContract.inventoryOutputTypeId === InventoryOutputTypeEnums.replacement && this.inventoryOutputContract.devolution !== null) {
      this.visibleDevolution = true;
      this.devolutionNumber = this.inventoryOutputContract.devolution.consecutive;
    } else {
      this.visibleDevolution = false;
      this.devolutionNumber = 0;
    }
    //Factura
    if (this.inventoryOutputContract.inventoryOutputTypeId === InventoryOutputTypeEnums.invoice && this.inventoryOutputContract.invoice !== null) {
      this.visibleInvoice = true;
      this.invoiceNumber = this.inventoryOutputContract.invoice.consecutive;
      //Busco el tipo de documento comercial de la factura o cuenta de cobro
      const bussinessDocumentsClassId = await firstValueFrom(
        this.inventoryOutputService.getBussinessDocumentsClassIdAsync(this.inventoryOutputContract.invoice.bussinessDocumentsTypeId)
      );
      //Valido la clase del tipo de documento comercial
      bussinessDocumentsClassId == BussinessDocumentsClassEnums.factura ? this.labelInvoice = true : this.labelInvoice = false;
    } else {
      this.visibleInvoice = false;
      this.invoiceNumber = 0;
    }
    if (this.inventoryOutputContract.inventoryOutputId === 0 || this.inventoryOutputContract.inventoryOutputId === null) {
      setTimeout(() => this.formInventoryOutput.controls["consecutive"].disable(), 100);
    } else {
      setTimeout(() => this.formInventoryOutput.controls["consecutive"].enable(), 100);
    }
    //Pedido interno
    if (this.inventoryOutputContract.swInternalOrder && this.quantityDetails > 0) {
      setTimeout(() => this.formControlStateService.setControlState(this.formInventoryOutput, ['swInternalOrder', 'internalOrderConsecutive'], false), 100);
    }
    //Si no es tipo salida, deshabilito el formulario
    if (this.inventoryOutputTypeId !== InventoryOutputTypeEnums.output) this.disabledForm = true;
  }

  async userAuthenticatedIsASADMIN() {
    try {
      this.isASADMIN = await firstValueFrom(this.userService.userAuthenticatedIsASADMIN());
    } catch (error) {
      console.error('Error al buscar si el usuario es ASADMIN', error);
    }
  }

  validateForm(inventoryOutput: InventoryOutputModel) {
    this.formInventoryOutput = this.formBuilder.group({
      inventoryId: [inventoryOutput.inventoryId, [Validators.required, Validators.min(1)]],
      branchId: [inventoryOutput.branchId, [Validators.required, Validators.min(1)]],
      inventoryOutputTypeId: [inventoryOutput.inventoryOutputTypeId, [Validators.required, Validators.min(1)]],
      consecutive: [inventoryOutput.consecutive],
      conceptId: [inventoryOutput.conceptId, [Validators.required, Validators.min(1)]],
      clientId: [inventoryOutput.clientId, [Validators.required, Validators.min(1)]],
      dateOutput: [inventoryOutput.dateOutput ? this.dateConverterService.convertUtcToLocalDate(inventoryOutput.dateOutput) : null, [Validators.required]],
      observation: [inventoryOutput.observation, [Validators.maxLength(250)]],
      swInternalOrder: inventoryOutput.swInternalOrder,
      internalOrderId: inventoryOutput.internalOrderId,
      internalOrderConsecutive: inventoryOutput.internalOrder?.consecutive || 0,
    });
    this.responsible = inventoryOutput.internalOrder?.responsible || '';
    this.setMaintenanceOrderDisplayFromInventoryOutput(inventoryOutput);
    this.updateFormState();
    this.changeRequieredInternalOrder();
  }

  validateTypeInventoryOutput(inventoryOutputTypeId: number, action: string) {
    const messages: Record<number, string> = {
      [InventoryOutputTypeEnums.replacement]: "Reposición",
      [InventoryOutputTypeEnums.invoice]: "Factura",
      [InventoryOutputTypeEnums.transfer]: "Traslado",
      [InventoryOutputTypeEnums.salesRemission]: "Remisión Venta",
    };

    const message = messages[inventoryOutputTypeId];

    if (message) {
      this.toastHandlerService.showToast(
        'warning',
        `Las salidas de tipo '${message}' NO se pueden ${action}`
      );
      return false;
    }
    return true;

  }

}
